(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-summary"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/cart-summary/cart-summary.ts — do not edit directly.
// src/sections/cart-summary/cart-summary.ts
"use strict";
(() => {
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-panel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Composant d'accordéon personnalisé
   * Gère l'expansion et la réduction d'une section de contenu
   * @extends HTMLElement
   */
  class TPanel extends HTMLElement {
    /**
     * @constructor
     * Initialise les éléments de l'accordéon
     */
    constructor() {
      super()
      this.initializeElements()
    }

    /**
     * Initialise les éléments DOM et les propriétés
     * @private
     */
    initializeElements() {
      this.toggleBtn = [...document.querySelectorAll('[data-panel-toggle]')]
      this.panel = this.querySelector('[data-panel]')
    }

    connectedCallback() {
      this.toggleBtn.forEach((btn) => {
        btn.addEventListener('click', this.handleToggle.bind(this))
      })
    }
    handleToggle() {
      this.panel.classList.toggle('is-open')
    }

    disconnectedCallback() {}
  }

  customElements.define('t-panel', TPanel)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-search"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/header-search/header-search.ts — do not edit directly.
// src/sections/header-search/header-search.ts
"use strict";
(() => {
  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSections(ids, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ sections: ids.join(",") }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
    return response.json();
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSections(targets, options = {}) {
    if (targets.length === 0) return;
    const map = options.sections ?? await fetchSections(
      targets.map((t) => t.id),
      options
    );
    for (const target of targets) {
      const html = map[target.id];
      if (typeof html !== "string") continue;
      if (target.selector) {
        swapInner(html, target.selector);
      } else {
        swapSection(target.id, html);
      }
    }
  }

  // src/sections/header-search/header-search.ts
  var TSearch = class extends HTMLElement {
    /**
     * @constructor
     * Initialise les propriétés du composant
     */
    constructor() {
      super();
      this.dialog = null;
      this.formPredictive = null;
      this.inputSearch = null;
      this.btnToggleSearch = [];
      this.sectionsRender = [];
      this.initializeElements();
      this.initializeSections();
      this.handleEscapeKey = this.handleEscapeKey.bind(this);
    }
    /**
     * Initialise les éléments DOM du composant
     * @private
     */
    initializeElements() {
      this.dialog = this.querySelector("[data-search-dialog]");
      this.formPredictive = this.querySelector(
        "[data-form-predictive-search]"
      );
      this.inputSearch = this.formPredictive?.querySelector(
        "input[type=search]"
      ) ?? null;
      this.btnToggleSearch = Array.from(
        document.querySelectorAll("[data-btn-toogle-search]")
      );
    }
    /**
     * Initialise la configuration des sections
     * @private
     */
    initializeSections() {
      this.sectionsRender = [
        {
          id: "header-search",
          selector: ["[data-predictive-result]"]
        }
      ];
    }
    /**
     * Callback appelé lorsque l'élément est connecté au DOM
     */
    connectedCallback() {
      this.setupEventListeners();
    }
    /**
     * Configure les écouteurs d'événements initiaux
     * @private
     */
    setupEventListeners() {
      this.toggleSearch();
      this.listenPredictiveSearch();
      window.addEventListener("keydown", this.handleEscapeKey);
    }
    /**
     * Callback appelé lorsque l'élément est déconnecté du DOM
     */
    disconnectedCallback() {
      this.cleanup();
    }
    handleEscapeKey(event) {
      if (event.key !== "Escape") return;
      if (!this.dialog?.open) return;
      event.preventDefault();
      this.toggleDialogState();
    }
    /**
     * Nettoie les écouteurs d'événements
     * @private
     */
    cleanup() {
      window.removeEventListener("keydown", this.handleEscapeKey);
    }
    listenPredictiveSearch() {
      this.formPredictive?.addEventListener(
        "input",
        this.fetchResultPredictive.bind(this)
      );
    }
    async fetchResultPredictive() {
      if (!this.formPredictive) return;
      const formData = new FormData(this.formPredictive);
      const input = formData.get("q");
      const searchQuery = typeof input === "string" ? input : "";
      try {
        if (searchQuery.length === 0) {
          await renderSections(this.sectionsRender);
          return;
        }
        const shopifyRoot = window.Shopify?.routes?.root ?? "/";
        const url = new URL(
          `${shopifyRoot}search/suggest?q=${encodeURIComponent(searchQuery)}&resources[type]=query,product&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=hide&[fields]=title,product_type,variants.title`,
          window.location.origin
        );
        await renderSections(this.sectionsRender, { url });
      } catch (error) {
        console.error("[TSearch] predictive section render failed:", error);
      }
    }
    /**
     * Gère l'affichage/masquage du filtre
     * @private
     */
    toggleSearch() {
      this.btnToggleSearch.forEach((btn) => {
        btn.addEventListener("click", () => this.toggleDialogState());
      });
    }
    /**
     * Bascule l'état du dialogue (ouvert/fermé)
     * @private
     */
    toggleDialogState() {
      if (!this.dialog) return;
      if (this.dialog.open) {
        document.documentElement.classList.remove("is-overflow-hidden");
        this.dialog.close();
      } else {
        document.documentElement.classList.add("is-overflow-hidden");
        this.dialog.showModal();
      }
    }
  };
  customElements.define("t-search", TSearch);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/header/header.ts — do not edit directly.
// src/sections/header/header.ts
"use strict";
(() => {
  // src/sections/header/hover-header.ts
  var DESKTOP_QUERY = "(min-width: 1024px)";
  var ROOT_ITEM_SELECTOR = ".menu__item:not(.menu__item--submenu)";
  var ANIMATED_CLASS = "is-menu-animated";
  var OPEN_CLASS = "is-submenu-open";
  var THoverHeader = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.menu = null;
      this.backdrop = null;
      this.rootItems = [];
      /** Item de niveau 1 dont le sous-menu est ouvert, ou `null`. */
      this.openItem = null;
      this.desktopQuery = window.matchMedia(DESKTOP_QUERY);
      /**
       * Vrai le temps de rendre le focus au déclencheur après `Escape` : évite que
       * le `focusin` provoqué par ce `focus()` ne rouvre aussitôt le sous-menu.
       */
      this.isRestoringFocus = false;
      // Références stables, indispensables pour retirer les écouteurs.
      this.boundPointerOver = (e) => this.handlePointerOver(e);
      this.boundMouseLeave = () => this.handleMouseLeave();
      this.boundBackdropEnter = () => this.handleMouseLeave();
      this.boundFocusIn = (e) => this.handleFocusIn(e);
      this.boundFocusOut = (e) => this.handleFocusOut(e);
      this.boundKeyDown = (e) => this.handleKeyDown(e);
      this.boundBreakpoint = () => this.syncBreakpoint();
    }
    connectedCallback() {
      this.menu = document.querySelector("t-menu");
      this.backdrop = document.querySelector(
        ".menu-dekstop-backdrop"
      );
      if (!this.menu) return;
      this.rootItems = Array.from(
        this.menu.querySelectorAll(ROOT_ITEM_SELECTOR)
      );
      this.menu.addEventListener("mouseover", this.boundPointerOver);
      this.menu.addEventListener("mouseleave", this.boundMouseLeave);
      this.backdrop?.addEventListener("mouseenter", this.boundBackdropEnter);
      this.menu.addEventListener("focusin", this.boundFocusIn);
      this.menu.addEventListener("focusout", this.boundFocusOut);
      this.menu.addEventListener("keydown", this.boundKeyDown);
      this.desktopQuery.addEventListener("change", this.boundBreakpoint);
      this.syncBreakpoint();
    }
    disconnectedCallback() {
      this.menu?.removeEventListener("mouseover", this.boundPointerOver);
      this.menu?.removeEventListener("mouseleave", this.boundMouseLeave);
      this.backdrop?.removeEventListener("mouseenter", this.boundBackdropEnter);
      this.menu?.removeEventListener("focusin", this.boundFocusIn);
      this.menu?.removeEventListener("focusout", this.boundFocusOut);
      this.menu?.removeEventListener("keydown", this.boundKeyDown);
      this.desktopQuery.removeEventListener("change", this.boundBreakpoint);
    }
    /** Sous-menu associé à un item de niveau 1 (ou `null` s'il n'en a pas). */
    getSubmenu(item) {
      return item.querySelector("[data-submenu]");
    }
    /** Déclencheur focalisable de niveau 1 (le `<a>`/`<span>` desktop). */
    getTrigger(item) {
      return item.querySelector(".menu__level-1--desktop");
    }
    /**
     * N'écrit dans le DOM que si l'état change réellement — même garde que
     * `setClass` de `menu.ts`, pour ne pas générer de mutations superflues.
     */
    setClass(el, className, on) {
      if (!el || el.classList.contains(className) === on) return;
      el.classList.toggle(className, on);
    }
    setInert(el, inert) {
      if (!el || el.hasAttribute("inert") === inert) return;
      if (inert) el.setAttribute("inert", "");
      else el.removeAttribute("inert");
    }
    setExpanded(el, expanded) {
      if (!el) return;
      const value = expanded ? "true" : "false";
      if (el.getAttribute("aria-expanded") !== value) {
        el.setAttribute("aria-expanded", value);
      }
    }
    /** Applique/retire l'état ouvert d'un item : classe, `inert`, `aria-expanded`. */
    setItemOpen(item, open) {
      this.setClass(item, OPEN_CLASS, open);
      const submenu = this.getSubmenu(item);
      if (submenu) this.setInert(submenu, !open);
      this.setExpanded(this.getTrigger(item), open);
    }
    /**
     * Ouvre le sous-menu d'un item. Si un autre est déjà ouvert, la bascule est
     * **instantanée** (on coupe l'animation), conforme au comportement voulu.
     */
    open(item) {
      if (this.openItem === item) return;
      if (this.openItem) {
        this.setClass(this.menu, ANIMATED_CLASS, false);
        this.setItemOpen(this.openItem, false);
      }
      this.setItemOpen(item, true);
      this.openItem = item;
    }
    /**
     * Ferme tout et **réarme l'animation** pour la fermeture et le prochain survol.
     *
     * Ordre critique : on réactive `is-menu-animated` puis on force un reflow
     * **avant** de retirer l'état ouvert. Sinon, après un mode instantané (2ᵉ
     * survol), le navigateur verrait le changement de `transition-duration`
     * (0s → 0.6s) et le changement de valeur dans un seul recalcul de style →
     * aucune transition ne démarrerait et la fermeture sauterait.
     */
    closeAll() {
      this.setClass(this.menu, ANIMATED_CLASS, true);
      void this.menu?.offsetWidth;
      this.rootItems.forEach((item) => this.setItemOpen(item, false));
      this.openItem = null;
    }
    /** Survol/focus d'un item : ouvre s'il a un sous-menu, sinon ferme l'ouvert. */
    activate(item) {
      if (this.getSubmenu(item)) this.open(item);
      else this.closeAll();
    }
    rootItemFrom(target) {
      const el = target instanceof Element ? target : null;
      const item = el?.closest(ROOT_ITEM_SELECTOR) ?? null;
      return item && this.menu?.contains(item) ? item : null;
    }
    handlePointerOver(e) {
      if (!this.desktopQuery.matches) return;
      const item = this.rootItemFrom(e.target);
      if (item) this.activate(item);
    }
    handleMouseLeave() {
      if (!this.desktopQuery.matches || !this.openItem) return;
      this.closeAll();
    }
    handleFocusIn(e) {
      if (!this.desktopQuery.matches || this.isRestoringFocus) return;
      const item = this.rootItemFrom(e.target);
      if (item) this.activate(item);
    }
    handleFocusOut(e) {
      if (!this.desktopQuery.matches) return;
      const related = e.relatedTarget;
      if (!related || !this.menu?.contains(related)) this.closeAll();
    }
    handleKeyDown(e) {
      if (!this.desktopQuery.matches) return;
      if (e.key === "Escape") {
        if (!this.openItem) return;
        const trigger = this.getTrigger(this.openItem);
        this.closeAll();
        if (trigger) {
          this.isRestoringFocus = true;
          trigger.focus();
          this.isRestoringFocus = false;
        }
        return;
      }
      if (e.key === "Enter" || e.key === " ") {
        const target = e.target;
        if (!target.matches("span.menu__level-1--desktop")) return;
        const item = target.closest(ROOT_ITEM_SELECTOR);
        if (!item || !this.getSubmenu(item)) return;
        e.preventDefault();
        if (this.openItem === item) this.closeAll();
        else this.open(item);
      }
    }
    /**
     * Synchronise l'état au (dé)franchissement du breakpoint.
     *
     * En **mobile**, on retire tout `inert` : le panneau mobile est piloté par
     * `menu.ts` via `.menu__submenu.is-open`, et un `[data-submenu]` resté `inert`
     * le rendrait inutilisable. En **desktop**, on repart d'un état fermé + animé.
     */
    syncBreakpoint() {
      this.openItem = null;
      if (this.desktopQuery.matches) {
        this.setClass(this.menu, ANIMATED_CLASS, true);
        this.rootItems.forEach((item) => this.setItemOpen(item, false));
        return;
      }
      this.rootItems.forEach((item) => {
        this.setClass(item, OPEN_CLASS, false);
        this.setInert(this.getSubmenu(item), false);
        this.setExpanded(this.getTrigger(item), false);
      });
    }
  };
  customElements.define("t-hover-header", THoverHeader);

  // src/sections/header/menu.ts
  var TMenu = class extends HTMLElement {
    constructor() {
      super();
      /** Timeout pour le basculement de l'en-tête */
      this.timeoutHeaderTransition = null;
      /** Retraits différés en vol, indexés par classe : évite d'empiler un timer par événement de scroll */
      this.pendingRemovals = {};
      /** Référence stable du handler, indispensable pour pouvoir le retirer */
      this.boundHandleScroll = () => this.handleScroll();
      this.initializeElements();
    }
    /**
     * Initialise les éléments DOM et les propriétés
     * @private
     */
    initializeElements() {
      this.btnToggleMenu = Array.from(
        document.querySelectorAll("[data-btn-toogle-menu]")
      );
      this.btnToggleSubMenu = Array.from(
        this.querySelectorAll("[data-submenu-toggle]")
      );
      this.subMenus = Array.from(
        this.querySelectorAll("[data-submenu]")
      );
      this.currentSubMenu = null;
      this.header = document.querySelector("header");
      this.headerInside = document.querySelector(".header-inside");
      this.headerSection = this.header.querySelector(".header__section");
      this.lastScrollY = void 0;
      this.timeoutHeaderTransition = null;
    }
    /**
     * Configure les écouteurs d'événements lorsque l'élément est connecté au DOM
     */
    connectedCallback() {
      this.setupSubMenuListeners();
      this.setupMainMenuListeners();
      this.setupScrollListener();
      this.updateProductVisualThresholdState(
        window.scrollY > this.getHeaderThreshold()
      );
    }
    /**
     * Configure les écouteurs d'événements pour les sous-menus
     * @private
     */
    setupSubMenuListeners() {
      this.btnToggleSubMenu?.forEach((btn) => {
        btn.addEventListener("click", () => this.handleSubMenuToggle(btn));
      });
    }
    /**
     * Gère le basculement des sous-menus
     * @param {HTMLElement} btn - Le bouton de basculement cliqué
     * @private
     */
    handleSubMenuToggle(btn) {
      this.currentSubMenu = this.subMenus?.find(
        (subMenu) => subMenu.dataset.id === btn.dataset.id
      );
      this.currentSubMenu?.classList.toggle("is-open");
    }
    /**
     * Configure les écouteurs d'événements pour le menu principal
     * @private
     */
    setupMainMenuListeners() {
      this.btnToggleMenu?.forEach((btn) => {
        btn.addEventListener("click", () => this.handleMainMenuToggle(btn));
      });
    }
    /**
     * Gère le basculement du menu principal
     * @param {HTMLElement} btn - Le bouton de basculement cliqué
     * @private
     */
    handleMainMenuToggle(btn) {
      this.classList.toggle("is-open");
      btn.classList.toggle("is-open");
      const headerTranparent = this.header.querySelector(".header--transparent");
      const headerTranparentMobile = this.header.querySelector(
        ".header--transparent__mobile"
      );
      if (headerTranparent || headerTranparentMobile) {
        this.header.classList.add("header--transition");
      }
      if (this.timeoutHeaderTransition) {
        clearTimeout(this.timeoutHeaderTransition);
      }
      this.timeoutHeaderTransition = setTimeout(() => {
        this.header?.classList.remove("header--transition");
        this.timeoutHeaderTransition = null;
      }, 900);
      const banner = document.querySelector(".banner");
      const freeShippingBanner = document.querySelector("#FreeShippingBanner");
      const headerTop = this.header?.getBoundingClientRect().top || 0;
      const sizefreeShippingBanner = freeShippingBanner?.getBoundingClientRect().height || 0;
      const sizeBanner = banner?.getBoundingClientRect().height || 0;
      if (banner && headerTop > 0 || this.header?.classList.contains("menu-is-open")) {
        const total = sizeBanner + sizefreeShippingBanner;
        this.header?.style.setProperty("--move-to", `${total}px`);
        this.header?.classList.toggle("menu-is-open");
      }
      if (!this.classList.contains("is-open")) {
        this.currentSubMenu?.classList.remove("is-open");
        document.documentElement.classList.remove("is-overflow-hidden");
      } else {
        document.documentElement.classList.add("is-overflow-hidden");
      }
      this.currentSubMenu?.scrollTo(0, 0);
    }
    /**
     * Configure l'écouteur d'événements pour le défilement
     * @private
     */
    setupScrollListener() {
      window.addEventListener("scroll", this.boundHandleScroll, { passive: true });
    }
    /**
     * N'écrit dans le DOM que si l'état de la classe change réellement.
     * `classList.add/remove/toggle` réécrivent l'attribut `class` même à état
     * identique : appelés à chaque événement de scroll, ils généraient une mutation
     * du DOM par pixel parcouru (nœuds qui clignotent dans l'inspecteur).
     * @private
     */
    setClass(element, className, on) {
      if (!element || element.classList.contains(className) === on) return;
      element.classList.toggle(className, on);
    }
    /**
     * Programme un retrait différé unique : sans ce garde, chaque événement de
     * scroll créait son propre `setTimeout`, empilant des centaines de timers qui
     * continuaient à muter le DOM bien après l'arrêt du scroll.
     * @private
     */
    scheduleRemoval(element, className) {
      if (!element || this.pendingRemovals[className]) return;
      this.pendingRemovals[className] = setTimeout(() => {
        this.pendingRemovals[className] = null;
        this.setClass(element, className, false);
      }, 300);
    }
    /**
     * Retourne le seuil à partir duquel le header change pendant le scroll.
     * Sur les pages produit desktop, il correspond au bas du VISUEL lorsque
     * celui-ci atteint le bas du viewport.
     * @returns {number}
     * @private
     */
    getHeaderThreshold() {
      const defaultThreshold = this.headerInside.offsetHeight * 2;
      const productVisual = this.getDesktopProductVisual();
      if (!productVisual) {
        return defaultThreshold;
      }
      const visualBottom = window.scrollY + productVisual.getBoundingClientRect().bottom;
      return Math.max(0, visualBottom - window.innerHeight);
    }
    /**
     * Retourne le visuel produit lorsque le seuil PDP desktop est actif.
     *
     * La galerie EN CONTENU, et non `.main-product__description` : les deux
     * colonnes de `.main-product__container` sont étirées à la plus haute, et
     * c'est la description qui la fixe. Elle porte la composition d'un coffret —
     * un item par produit — et le dépliage de la description longue. Mesuré : le
     * seuil passait de 258 à 5242 entre deux et trente produits, et gagnait 80px
     * au seul clic sur « Read more ». Le header transparent doit basculer quand
     * le visuel a fini de passer derrière lui, ce qui ne dépend ni du nombre de
     * produits listés en face ni de l'état d'un bloc de texte.
     *
     * Deux sections produit, deux markups de visuel, et aucune des deux classes
     * ne se rencontre chez l'autre : `main-product-v2` rend `gallery-main-product`,
     * la section legacy `main-product` — seule `product.minimalist` l'appelle —
     * ses slides `main-product__image-container`. Sans le second sélecteur, cette
     * page retomberait en silence sur le seuil par défaut.
     *
     * @returns {Element|null}
     * @private
     */
    getDesktopProductVisual() {
      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      if (!isDesktop) {
        return null;
      }
      return document.querySelector(
        ".body--product .main-product__gallery .gallery-main-product.v-desktop, .body--product .main-product__image-container"
      );
    }
    /**
     * Met à jour la position spécifique du header sur le PDP desktop.
     * @param {boolean} hasPassedThreshold
     * @private
     */
    updateProductVisualThresholdState(hasPassedThreshold) {
      const usesProductVisualThreshold = Boolean(
        this.getDesktopProductVisual()
      );
      this.setClass(
        this.header,
        "has-product-visual-threshold",
        usesProductVisualThreshold
      );
      this.setClass(
        this.header,
        "is-product-visual-passed",
        usesProductVisualThreshold && hasPassedThreshold
      );
    }
    /**
     * Gère le comportement du menu lors du défilement
     * @private
     */
    handleScroll() {
      if (this.lastScrollY === void 0) {
        this.lastScrollY = window.scrollY + this.headerInside.offsetHeight * 2;
      }
      const headerThreshold = this.getHeaderThreshold();
      const scrollDownThreshold = this.headerInside.offsetHeight * 2;
      const isScrollingDown = window.scrollY > this.lastScrollY;
      const hasPassedThreshold = window.scrollY > headerThreshold;
      const hasPassedScrollDownThreshold = window.scrollY > scrollDownThreshold;
      const stickyDosoon = document.querySelector(".sticky-doson .sticky");
      const stickySize = stickyDosoon?.getBoundingClientRect();
      this.updateProductVisualThresholdState(hasPassedThreshold);
      if (isScrollingDown && hasPassedScrollDownThreshold) {
        this.setClass(this.header, "is-scroll-down", true);
      } else if (!isScrollingDown) {
        this.setClass(this.header, "is-scroll-down", false);
      }
      if (!isScrollingDown && hasPassedThreshold) {
        if (this.headerSection.classList.contains("header--grid")) {
          this.setClass(this.headerSection, "header--transparent", false);
        }
        if (this.headerSection.classList.contains("header--grid-mobile")) {
          this.setClass(this.headerSection, "header--transparent__mobile", false);
        }
        if (stickyDosoon && stickySize?.top == headerThreshold + 2) {
          this.setClass(stickyDosoon, "is-show", true);
        }
        if (stickyDosoon && stickySize && stickySize.top > headerThreshold + 2) {
          this.setClass(stickyDosoon, "is-show", false);
        }
      } else if (isScrollingDown && hasPassedThreshold) {
        if (this.headerSection.classList.contains("header--grid")) {
          this.scheduleRemoval(this.headerSection, "header--transparent");
        }
        if (this.headerSection.classList.contains("header--grid-mobile")) {
          this.scheduleRemoval(this.headerSection, "header--transparent__mobile");
        }
        if (stickyDosoon && stickySize?.top == 0) {
          this.setClass(stickyDosoon, "is-show", true);
        }
      } else {
        if (this.headerSection.classList.contains("header--grid")) {
          this.setClass(this.headerSection, "header--transparent", true);
        }
        if (this.headerSection.classList.contains("header--grid-mobile")) {
          this.setClass(this.headerSection, "header--transparent__mobile", true);
        }
        this.setClass(stickyDosoon, "is-show", false);
      }
      this.lastScrollY = window.scrollY;
    }
    /**
     * Nettoie les écouteurs d'événements lors de la déconnexion
     */
    disconnectedCallback() {
      window.removeEventListener("scroll", this.boundHandleScroll);
      Object.values(this.pendingRemovals).forEach((timer) => {
        if (timer) clearTimeout(timer);
      });
      this.pendingRemovals = {};
    }
  };
  customElements.define("t-menu", TMenu);
  var mobileSearchBar = class extends HTMLElement {
    constructor() {
      super();
      // NB : ne jamais nommer ce champ `onclick` — la cible esbuild (es2020) abaisse
      // les class fields en assignations constructeur, ce qui déclencherait le setter
      // natif `onclick` en plus du addEventListener → double appel → ouverture/fermeture
      // immédiate du dialog de recherche.
      this.handleClick = () => {
        this.searchIcon?.click();
      };
    }
    connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }
    get searchIcon() {
      return this.closest(".shopify-section")?.querySelector(
        "[data-btn-toogle-search]"
      ) ?? null;
    }
  };
  if (!window.customElements.get("mobile-search-bar")) {
    window.customElements.define("mobile-search-bar", mobileSearchBar);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-collection"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/hero-collection/hero-collection.ts — do not edit directly.
// src/sections/hero-collection/hero-collection.ts
"use strict";
(() => {
  // src/sections/hero-collection/hero-collection.ts
  var TTuncat = class extends HTMLElement {
    constructor() {
      super();
      this.maxLines = 2;
      this.content = null;
      this.label = null;
      this.checkbox = null;
      this.originalHTML = "";
      this.plainChars = [];
      this.seeMoreText = "";
      this.seeLessText = "";
      this.truncatedView = null;
      this.fullView = null;
      this.resizeTimeout = null;
      this._boundDebouncedRender = null;
    }
    connectedCallback() {
      this.initialize();
      this.setupEventListeners();
    }
    initialize() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.label = this.querySelector("label");
      if (this.label) {
        const seeMoreSpan = this.label.querySelector(
          ".hero-collection_description_see-more"
        );
        const seeLessSpan = this.label.querySelector(
          ".hero-collection_description_see-less"
        );
        if (seeMoreSpan) this.seeMoreText = seeMoreSpan.textContent?.trim() ?? "";
        if (seeLessSpan) this.seeLessText = seeLessSpan.textContent?.trim() ?? "";
        this.label.style.display = "none";
      }
      this.setupContent();
      this.render();
    }
    /**
     * Localise (ou crée) le paragraphe de contenu et mémorise le HTML d'origine
     * ainsi que sa version texte brut découpée en graphèmes (surrogate-safe).
     */
    setupContent() {
      this.content = this.querySelector("p");
      if (!this.content) {
        const contentNodes = [];
        Array.from(this.childNodes).forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node;
            const tag = el.tagName.toLowerCase();
            if (tag === "input" || tag === "label") return;
          }
          if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim() || node.nodeType === Node.ELEMENT_NODE) {
            contentNodes.push(node);
          }
        });
        if (contentNodes.length > 0) {
          this.content = document.createElement("p");
          contentNodes.forEach((node) => {
            this.content.appendChild(node.cloneNode(true));
            if (node.parentNode === this) this.removeChild(node);
          });
          if (this.checkbox) {
            this.insertBefore(this.content, this.checkbox.nextSibling);
          } else {
            this.insertBefore(this.content, this.firstChild);
          }
        }
      }
      if (this.content) {
        this.originalHTML = this.content.innerHTML;
        const plain = (this.content.textContent ?? "").replace(/\s+/g, " ").trim();
        this.plainChars = Array.from(plain);
      }
      this.style.display = "block";
      this.style.textAlign = "center";
      if (this.content) {
        this.content.style.maxWidth = "653px";
        this.content.style.margin = "0 auto";
      }
    }
    setupEventListeners() {
      if (this.checkbox) {
        this.checkbox.addEventListener("change", this.handleToggle.bind(this));
      }
      this._boundDebouncedRender = this.debouncedRender.bind(this);
      window.addEventListener("resize", this._boundDebouncedRender);
    }
    debouncedRender() {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.render(), 200);
    }
    /**
     * Crée un clone hors écran calé sur la largeur et la typographie réelles du
     * contenu, pour mesurer la hauteur rendue d'un texte candidat.
     */
    createMeasurer(cs) {
      const width = this.content.clientWidth || 653;
      const measurer = document.createElement("div");
      measurer.style.cssText = [
        "position:absolute",
        "left:-99999px",
        "top:0",
        "visibility:hidden",
        "height:auto",
        "overflow:visible",
        "white-space:normal",
        `width:${width}px`,
        `font-size:${cs.fontSize}`,
        `font-family:${cs.fontFamily}`,
        `font-weight:${cs.fontWeight}`,
        `font-style:${cs.fontStyle}`,
        `letter-spacing:${cs.letterSpacing}`,
        `line-height:${cs.lineHeight}`,
        `text-align:${cs.textAlign}`,
        `word-break:${cs.wordBreak}`,
        `overflow-wrap:${cs.overflowWrap}`
      ].join(";");
      return measurer;
    }
    /**
     * Reconstruit l'affichage : mesure le débordement et, le cas échéant, calcule
     * par dichotomie le plus long texte qui tient en `maxLines` lignes une fois le
     * bouton « voir plus » inclus.
     */
    render() {
      if (!this.content) return;
      this.truncatedView = null;
      this.fullView = null;
      this.content.innerHTML = this.originalHTML;
      this.content.style.display = "block";
      this.content.style.webkitLineClamp = "unset";
      this.content.style.overflow = "visible";
      const cs = window.getComputedStyle(this.content);
      const lineHeight = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.4;
      const maxHeight = lineHeight * this.maxLines + 1;
      const measurer = this.createMeasurer(cs);
      document.body.appendChild(measurer);
      measurer.textContent = this.plainChars.join("");
      const overflows = measurer.scrollHeight > maxHeight;
      if (!overflows) {
        document.body.removeChild(measurer);
        this.content.innerHTML = this.originalHTML;
        this.classList.add("is-ready");
        return;
      }
      const suffix = "\u2026 " + this.seeMoreText;
      const fits = (count) => {
        measurer.textContent = this.plainChars.slice(0, count).join("") + suffix;
        return measurer.scrollHeight <= maxHeight;
      };
      let lo = 0;
      let hi = this.plainChars.length;
      let best = 0;
      while (lo <= hi) {
        const mid = lo + hi >> 1;
        if (fits(mid)) {
          best = mid;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }
      document.body.removeChild(measurer);
      let truncatedText = this.plainChars.slice(0, best).join("");
      truncatedText = truncatedText.replace(/[\s.,;:]+$/u, "");
      this.buildViews(truncatedText);
      this.applyState(!!(this.checkbox && this.checkbox.checked));
      this.classList.add("is-ready");
    }
    buildViews(truncatedText) {
      if (!this.content) return;
      const truncatedContainer = document.createElement("span");
      truncatedContainer.className = "truncated-view";
      truncatedContainer.appendChild(
        document.createTextNode(truncatedText + "\u2026 ")
      );
      const seeMoreBtn = document.createElement("a");
      seeMoreBtn.className = "hero-collection_description_see-more inline-toggle-link";
      seeMoreBtn.textContent = this.seeMoreText;
      seeMoreBtn.setAttribute("role", "button");
      seeMoreBtn.style.cssText = "cursor:pointer;text-decoration:underline;color:var(--color-gray);display:inline;white-space:nowrap;";
      seeMoreBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.setExpanded(true);
      });
      truncatedContainer.appendChild(seeMoreBtn);
      const fullContainer = document.createElement("div");
      fullContainer.className = "full-view";
      fullContainer.innerHTML = this.originalHTML;
      const seeLessBtn = document.createElement("a");
      seeLessBtn.className = "hero-collection_description_see-less";
      seeLessBtn.textContent = this.seeLessText;
      seeLessBtn.setAttribute("role", "button");
      seeLessBtn.style.cssText = "display:block;margin-top:8px;cursor:pointer;text-decoration:underline;color:var(--color-gray);";
      seeLessBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.setExpanded(false);
      });
      fullContainer.appendChild(seeLessBtn);
      this.content.innerHTML = "";
      this.content.appendChild(truncatedContainer);
      this.content.appendChild(fullContainer);
      this.truncatedView = truncatedContainer;
      this.fullView = fullContainer;
    }
    setExpanded(expanded) {
      if (this.checkbox) {
        this.checkbox.checked = expanded;
        this.checkbox.dispatchEvent(new Event("change"));
      } else {
        this.applyState(expanded);
      }
    }
    handleToggle() {
      if (!this.checkbox) return;
      this.applyState(this.checkbox.checked);
    }
    applyState(isExpanded) {
      if (!this.truncatedView || !this.fullView) return;
      if (isExpanded) {
        this.truncatedView.style.display = "none";
        this.fullView.style.display = "block";
        this.classList.add("is-expanded");
      } else {
        this.truncatedView.style.display = "inline";
        this.fullView.style.display = "none";
        this.classList.remove("is-expanded");
      }
    }
    disconnectedCallback() {
      if (this._boundDebouncedRender) {
        window.removeEventListener("resize", this._boundDebouncedRender);
      }
    }
  };
  if (!customElements.get("t-tuncat")) {
    customElements.define("t-tuncat", TTuncat);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/main-cart/main-cart.ts — do not edit directly.
// src/sections/main-cart/main-cart.ts
"use strict";
(() => {
  // src/shared/cart-a11y/cart-a11y.ts
  var CART_LIVE_STATUS_ID = "cart-live-status";
  var CART_A11Y_PENDING_KEY = "cart-a11y-announce";
  var FOCUS_ANNOUNCE_DELAY_MS = 300;
  var RELOAD_ANNOUNCE_DELAY_MS = 600;
  function getOrCreateCartLiveRegion() {
    let region = document.getElementById(CART_LIVE_STATUS_ID);
    if (region instanceof HTMLElement) {
      return region;
    }
    region = document.createElement("div");
    region.id = CART_LIVE_STATUS_ID;
    region.className = "sr-only form-status";
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", "polite");
    region.setAttribute("aria-atomic", "true");
    document.body.appendChild(region);
    return region;
  }
  function announceCartStatus(message, options = {}) {
    const trimmed = message.trim();
    if (!trimmed) return;
    const shouldFocus = options.focus !== false;
    const region = getOrCreateCartLiveRegion();
    if (shouldFocus) {
      region.setAttribute("aria-live", "off");
      region.setAttribute("tabindex", "-1");
      region.textContent = trimmed;
      region.focus({ preventScroll: true });
      window.setTimeout(() => {
        region.setAttribute("aria-live", "polite");
      }, FOCUS_ANNOUNCE_DELAY_MS);
      return;
    }
    region.textContent = "";
    requestAnimationFrame(() => {
      region.textContent = trimmed;
    });
  }
  function queueCartStatusForReload(message) {
    const trimmed = message.trim();
    if (!trimmed) return;
    try {
      sessionStorage.setItem(CART_A11Y_PENDING_KEY, trimmed);
    } catch {
    }
  }
  function flushPendingCartStatus() {
    let message = null;
    try {
      message = sessionStorage.getItem(CART_A11Y_PENDING_KEY);
      if (message) {
        sessionStorage.removeItem(CART_A11Y_PENDING_KEY);
      }
    } catch {
      return;
    }
    if (!message) return;
    window.setTimeout(() => {
      announceCartStatus(message);
    }, RELOAD_ANNOUNCE_DELAY_MS);
  }
  function fillCartStatusTemplate(template, values) {
    let result = template;
    if (values.title !== void 0) {
      result = result.replace(/__TITLE__/g, values.title);
    }
    if (values.quantity !== void 0) {
      result = result.replace(/__QUANTITY__/g, String(values.quantity));
    }
    return result;
  }

  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function getSectionId(el) {
    if (!el?.id?.startsWith(SECTION_PREFIX)) return null;
    return el.id.slice(SECTION_PREFIX.length);
  }
  function closestSectionId(el) {
    const wrapper = el?.closest(`[id^="${SECTION_PREFIX}"]`);
    return getSectionId(wrapper);
  }
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSections(ids, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ sections: ids.join(",") }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
    return response.json();
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSections(targets, options = {}) {
    if (targets.length === 0) return;
    const map = options.sections ?? await fetchSections(
      targets.map((t) => t.id),
      options
    );
    for (const target of targets) {
      const html = map[target.id];
      if (typeof html !== "string") continue;
      if (target.selector) {
        swapInner(html, target.selector);
      } else {
        swapSection(target.id, html);
      }
    }
  }

  // src/sections/main-cart/cart-discount.ts
  var CartDiscount = class extends HTMLElement {
    constructor() {
      super();
      this.onClick = () => this.handleButtonClick();
      this.container = this.querySelector("[data-cart-discount]");
      this.button = this.container?.querySelector(".button") ?? null;
      this.input = this.container?.querySelector("[data-cart-discount-input]") ?? null;
      this.errorElement = this.container?.querySelector("[data-discount-error]") ?? null;
    }
    connectedCallback() {
      this.button?.addEventListener("click", this.onClick);
    }
    disconnectedCallback() {
      this.removeEvents();
    }
    removeEvents() {
      this.button?.removeEventListener("click", this.onClick);
    }
    handleButtonClick() {
      if (this.button?.hasAttribute("data-cart-discount-apply")) {
        this.applyDiscount();
      } else if (this.button?.hasAttribute("data-cart-discount-remove")) {
        this.removeDiscount();
      }
    }
    async applyDiscount() {
      this.errorElement?.classList.add("hide");
      const code = this.input?.value.trim();
      if (!code) return;
      await this.submit(code, (data) => {
        if (data.discount_codes?.[0]?.applicable === false) {
          this.showError();
          return false;
        }
        return true;
      });
    }
    async removeDiscount() {
      await this.submit("", () => true);
    }
    // Une seule requête : le HTML des sections revient dans la réponse de
    // update.js (bundled section rendering), au lieu d'un second aller-retour
    // `?sections=` une fois le code appliqué.
    async submit(discount, shouldRender) {
      if (!this.button) return;
      const targets = this.getSectionTargets();
      this.setPending(true);
      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || "/"}cart/update.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              discount,
              sections: targets.map((target) => target.id).join(",")
            })
          }
        );
        if (!response.ok) {
          throw new Error(`Discount update failed: ${response.status}`);
        }
        const data = await response.json();
        if (shouldRender(data)) await this.renderCartSections(data, targets);
      } catch (error) {
        console.error("[CartDiscount] discount update error:", error);
        this.showError();
      } finally {
        this.setPending(false);
      }
    }
    // Le récap (cart-summary, porteur des deux formulaires mobile/desktop) et les
    // lignes (main-cart, prix remisés) changent avec un code. Ne rafraîchir que
    // `[data-cart-total]` laissait le total et le formulaire mobiles périmés
    // (« Appliquer » au lieu de « Supprimer »).
    getSectionTargets() {
      const summaryId = closestSectionId(this);
      return [
        { id: "main-cart", selector: ["[data-cart-items]"] },
        // Outer swap, as in product-form: the summary content is gated by
        // `cart.item_count`, which an inner swap cannot follow.
        ...summaryId ? [{ id: summaryId }] : []
      ];
    }
    async renderCartSections(data, targets) {
      try {
        if (!data.sections) throw new Error("No sections in the cart response");
        await renderSections(targets, { sections: data.sections });
      } catch (error) {
        console.error("[CartDiscount] section render failed:", error);
        window.location.reload();
      }
    }
    setPending(pending) {
      if (this.button) this.button.disabled = pending;
      if (this.input) this.input.readOnly = pending;
      if (pending) this.setAttribute("aria-busy", "true");
      else this.removeAttribute("aria-busy");
    }
    showError() {
      this.errorElement?.classList.remove("hide");
    }
  };
  customElements.define("cart-discount", CartDiscount);

  // src/shared/cart-limit-error/cart-limit-error.ts
  var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
  var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
  var OPEN_ENGRAVING_PANEL_SELECTOR = "c-engraving-panel.is-open";
  var SEARCH_DIALOG_SELECTOR = "dialog[data-search-dialog]";
  var QUANTITY_LIMIT_PATTERNS = [
    /can'?t add more/i,
    /maximum allowed quantity/i,
    /maximum quantity/i,
    /quantity.*exceeded/i,
    /only add \d+/i
  ];
  function getErrorMessageEl() {
    return document.querySelector(ERROR_MESSAGE_SELECTOR);
  }
  function getDefaultMessage() {
    return window.cartStrings?.addToCartLimitError ?? "The maximum allowed quantity for this product has been exceeded.";
  }
  function isCartQuantityLimitError(status, description) {
    if (status !== 422) return false;
    const normalized = description.trim();
    if (normalized.length === 0) return true;
    return QUANTITY_LIMIT_PATTERNS.some((pattern) => pattern.test(normalized));
  }
  function closeOpenEngravingPanels() {
    document.querySelectorAll(OPEN_ENGRAVING_PANEL_SELECTOR).forEach((panel) => {
      ;
      panel.close();
    });
  }
  function closeHeaderSearchIfOpen() {
    const openDialogs = document.querySelectorAll(
      `${SEARCH_DIALOG_SELECTOR}[open]`
    );
    if (openDialogs.length === 0) return;
    document.documentElement.classList.remove("is-overflow-hidden");
    openDialogs.forEach((dialog) => {
      dialog.close();
    });
  }
  function showCartLimitError(message) {
    closeHeaderSearchIfOpen();
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = message ?? getDefaultMessage();
    }
    errorMessage.classList.remove("hidden");
    errorMessage.removeAttribute("hidden");
    errorMessage.setAttribute("aria-hidden", "false");
    closeOpenEngravingPanels();
    window.scrollTo(0, 0);
  }
  function hideCartLimitError() {
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = "";
    }
    errorMessage.classList.add("hidden");
    errorMessage.setAttribute("hidden", "");
    errorMessage.setAttribute("aria-hidden", "true");
  }

  // src/sections/main-cart/cart-item-quantity.ts
  var CartItemQuantity = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="number"]');
      this.minusButton = this.querySelector('[data-action="minus"]');
      this.plusButton = this.querySelector('[data-action="plus"]');
      this.allSample = [
        ...document.querySelectorAll("[data-parent-id]")
      ];
      this.varaintId = this.dataset.variantId;
      this.urlChange = this.dataset.url;
      this.lineIndex = this.getAttribute("data-line");
      this.originalQuantity = parseInt(
        this.getAttribute("data-original-quantity") || this.input.value,
        10
      );
      this.maxQuantity = parseInt(this.input.getAttribute("max") || "0", 10);
      this.init();
    }
    init() {
      this.bindEvents();
      this.setOriginalQuantity();
      this.updateButtonStates();
    }
    bindEvents() {
      if (this.minusButton) {
        this.minusButton.addEventListener("click", this.handleMinus.bind(this));
      }
      if (this.plusButton) {
        this.plusButton.addEventListener("click", this.handlePlus.bind(this));
      }
      this.input.addEventListener("change", this.handleChange.bind(this));
      this.input.addEventListener("input", this.handleInput.bind(this));
      this.input.addEventListener("keypress", this.handleKeypress.bind(this));
      this.input.addEventListener("keydown", this.handleKeydown.bind(this));
    }
    handleMinus() {
      const currentValue = parseInt(this.input.value, 10);
      if (currentValue > 1) {
        this.input.value = (currentValue - 1).toString();
        this.handleChange();
      }
    }
    handlePlus() {
      const currentValue = parseInt(this.input.value, 10);
      if (this.maxQuantity > 0 && currentValue >= this.maxQuantity) {
        showCartLimitError();
        return;
      }
      this.input.value = (currentValue + 1).toString();
      this.handleChange();
    }
    handleChange() {
      let newQuantity = parseInt(this.input.value, 10);
      if (isNaN(newQuantity) || newQuantity < 1) {
        this.input.value = this.originalQuantity.toString();
        newQuantity = this.originalQuantity;
      } else if (this.maxQuantity > 0 && newQuantity > this.maxQuantity) {
        this.input.value = this.maxQuantity.toString();
        newQuantity = this.maxQuantity;
        showCartLimitError();
      } else {
        hideCartLimitError();
      }
      if (newQuantity !== this.originalQuantity) {
        this.updateQuantity(newQuantity);
      }
      this.updateButtonStates();
    }
    handleKeypress(e) {
      e.preventDefault();
      if (e.key === "Enter") {
        this.input.blur();
      }
    }
    handleKeydown(e) {
      if ([8, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1) {
        return;
      }
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        return;
      }
      if (e.keyCode >= 96 && e.keyCode <= 105) {
        return;
      }
      e.preventDefault();
    }
    handleInput() {
      const cleanValue = this.input.value.replace(/[^0-9]/g, "");
      if (cleanValue !== this.input.value) {
        this.input.value = cleanValue;
      }
      const currentValue = parseInt(cleanValue, 10);
      this.input.classList.remove("error");
      if (this.maxQuantity > 0 && currentValue > this.maxQuantity) {
        this.input.value = this.maxQuantity.toString();
        this.input.classList.add("error");
        showCartLimitError();
      } else if (currentValue < 1) {
        this.input.classList.add("error");
      } else {
        hideCartLimitError();
      }
      this.updateButtonStates();
    }
    updateButtonStates() {
      const currentValue = parseInt(this.input.value, 10);
      if (this.minusButton) {
        this.minusButton.classList.toggle(
          "cart__item-quantity-button--disabled",
          currentValue == 0
        );
      }
      if (this.plusButton) {
        this.plusButton.classList.toggle(
          "cart__item-quantity-button--disabled",
          this.maxQuantity > 0 && currentValue >= this.maxQuantity
        );
      }
    }
    updateQuantity(quantity) {
      const formData = new FormData();
      const sampleProduct = this.allSample.find(
        (sample) => sample.dataset.parentId == this.varaintId
      );
      if (sampleProduct != void 0) {
        formData.append(
          `updates[${sampleProduct.dataset.childId}]`,
          quantity.toString()
        );
      }
      formData.append(`updates[${this.varaintId}]`, quantity.toString());
      fetch((window.Shopify?.routes?.root || "/") + "cart/update.js", {
        method: "POST",
        body: formData
      }).then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          const rawMessage = errorData.description || errorData.message || `Erreur ${response.status}`;
          if (isCartQuantityLimitError(response.status, rawMessage)) {
            showCartLimitError();
          } else {
            showCartLimitError(rawMessage);
          }
          this.reset();
          return;
        }
        hideCartLimitError();
        this.queueQuantityUpdatedAnnouncement(quantity);
        window.location.reload();
      }).catch(() => {
        this.reset();
      });
    }
    /**
     * Persists a quantity-updated message for the next cart page load.
     */
    queueQuantityUpdatedAnnouncement(quantity) {
      const title = this.dataset.productTitle?.trim() || "Item";
      const template = this.dataset.quantityUpdatedTemplate || "__TITLE__ quantity updated to __QUANTITY__";
      queueCartStatusForReload(
        fillCartStatusTemplate(template, { title, quantity })
      );
    }
    setOriginalQuantity() {
      this.originalQuantity = parseInt(this.input.value, 10);
      this.setAttribute("data-original-quantity", this.input.value);
    }
    updateOriginalQuantity() {
      this.originalQuantity = parseInt(this.input.value, 10);
      this.setOriginalQuantity();
    }
    reset() {
      this.input.value = this.originalQuantity.toString();
      this.input.classList.remove("error");
      this.updateButtonStates();
    }
    get quantity() {
      return parseInt(this.input.value, 10);
    }
    set quantity(value) {
      this.input.value = value.toString();
      this.updateButtonStates();
    }
  };
  customElements.define("cart-item-quantity", CartItemQuantity);

  // src/sections/main-cart/main-cart.ts
  flushPendingCartStatus();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/main-collection/main-collection.ts — do not edit directly.
// src/sections/main-collection/main-collection.ts
"use strict";
(() => {
  // src/shared/card-product/predecode-hover-visuals.ts
  var HOVER_IMAGE_SELECTOR = ".card-product_image.is-hover-active figure:nth-child(even) img";
  var NEAR_VIEWPORT_MARGIN = "400px";
  var seen = /* @__PURE__ */ new WeakSet();
  var observer = null;
  function whenIdle(task) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(task, { timeout: 2e3 });
      return;
    }
    window.setTimeout(task, 200);
  }
  function decodeWhenLoaded(image) {
    const decode = () => whenIdle(() => void image.decode().catch(() => {
    }));
    if (image.complete && image.naturalWidth > 0) {
      decode();
      return;
    }
    image.addEventListener("load", decode, { once: true });
  }
  function nearViewportObserver() {
    if (observer) return observer;
    if (typeof IntersectionObserver !== "function") return null;
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer?.unobserve(entry.target);
          decodeWhenLoaded(entry.target);
        }
      },
      { rootMargin: NEAR_VIEWPORT_MARGIN }
    );
    return observer;
  }
  function predecodeHoverVisuals(root) {
    const images = root.querySelectorAll(HOVER_IMAGE_SELECTOR);
    if (images.length === 0) return;
    const io = nearViewportObserver();
    for (const image of images) {
      if (seen.has(image)) continue;
      seen.add(image);
      if (!io) {
        decodeWhenLoaded(image);
        continue;
      }
      io.observe(image);
    }
  }

  // src/sections/main-collection/main-collection.ts
  var TCollection = class extends HTMLElement {
    /**
     * @constructor
     * Initialise les éléments et les événements
     */
    constructor() {
      super();
      this.btnMore = null;
      this.currentPage = 1;
      this.isLoading = false;
      this.maxPages = 1;
      this.pageInload = null;
      this.loadMoreProducts = this.loadMoreProducts.bind(this);
      this.checkUrlOnLoad = this.checkUrlOnLoad.bind(this);
      this.initElements();
      this.bindEvents();
      this.checkUrlOnLoad();
    }
    static get observedAttributes() {
      return ["data-re-render"];
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;
      if (name == "data-re-render" && newValue === "true") {
        this.initElements();
        this.bindEvents();
      }
    }
    /**
     * Initialise les éléments DOM nécessaires
     * @private
     */
    initElements() {
      this.btnMore = this.querySelector("[data-more]");
      this.maxPages = parseInt(this.btnMore?.dataset.maxPages || "1", 10);
      this.currentPage = 1;
      this.isLoading = false;
      this.pageInload = null;
      predecodeHoverVisuals(this);
    }
    /**
     * Associe les événements aux éléments
     * @private
     */
    bindEvents() {
      if (this.btnMore) {
        this.btnMore.removeEventListener("click", this.loadMoreProducts);
        this.btnMore.addEventListener("click", this.loadMoreProducts);
      }
      window.removeEventListener("popstate", this.checkUrlOnLoad);
      window.addEventListener("popstate", this.checkUrlOnLoad);
    }
    /**
     * Vérifie l'URL lors du chargement de la page pour charger la bonne page de produits
     * @private
     */
    checkUrlOnLoad() {
      const params = new URLSearchParams(window.location.search);
      const pageParam = params.get("page");
      const pageInload = pageParam ? parseInt(pageParam, 10) : null;
      if (pageParam) {
        const pageNumber = parseInt(pageParam, 10);
        if (pageNumber > 1 && pageNumber <= this.maxPages) {
          this.currentPage = 1;
          this.loadPagesSequentially(pageNumber, pageInload);
        }
      }
    }
    /**
     * Charge séquentiellement les pages de produits jusqu'à la page cible
     * @param {number} targetPage - La page cible à atteindre
     * @private
     */
    async loadPagesSequentially(targetPage, pageInload) {
      this.isLoading = true;
      for (let i = 1; i <= targetPage; i++) {
        await this.fetchPage(i, pageInload);
        this.currentPage = i;
      }
      this.isLoading = false;
      this.updateMoreButton();
    }
    /**
     * Charge plus de produits au clic sur le bouton "more"
     * @private
     */
    async loadMoreProducts() {
      if (this.isLoading) return;
      if (!this.btnMore) return;
      const nextPageUrl = this.btnMore.dataset.next;
      if (!nextPageUrl) return;
      const pageNumber = new URLSearchParams(nextPageUrl.split("?")[1]).get(
        "page"
      );
      if (!pageNumber) return;
      this.isLoading = true;
      history.pushState("", "", nextPageUrl);
      await this.fetchPage(pageNumber);
      this.currentPage = parseInt(pageNumber, 10);
      this.isLoading = false;
      this.updateMoreButton();
    }
    /**
     * Récupère les produits d'une page spécifique
     * @param {number|string} pageNumber - Le numéro de la page à récupérer
     * @private
     */
    async fetchPage(pageNumber, pageInload = null) {
      try {
        if (!this.btnMore) return;
        const nextPageUrl = this.btnMore.dataset.next;
        if (!nextPageUrl) return;
        const url = `${nextPageUrl}&sections=main-collection`;
        const response = await fetch(url);
        if (!response.ok) {
          console.error(
            "Erreur lors du chargement de la page:",
            response.statusText
          );
          return;
        }
        const data = await response.json();
        let targetContainer;
        if (pageInload == pageNumber) {
          targetContainer = document.querySelector(`[data-grid-collection]`);
        } else {
          targetContainer = document.querySelector(`#pages${pageNumber}`);
          targetContainer?.classList.add("is-active");
        }
        if (targetContainer && data["main-collection"]) {
          const parsedContent = new DOMParser().parseFromString(data["main-collection"], "text/html").querySelector("[data-grid-collection]");
          if (parsedContent) {
            targetContainer.innerHTML = parsedContent.innerHTML;
          }
        }
        const btnMoreContainer = document.querySelector("[data-rerender-more]");
        if (btnMoreContainer && data["main-collection"]) {
          const newBtnContent = new DOMParser().parseFromString(data["main-collection"], "text/html").querySelector("[data-rerender-more]");
          if (newBtnContent) {
            btnMoreContainer.innerHTML = newBtnContent.innerHTML;
            this.initElements();
            this.bindEvents();
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des produits:", error);
        this.isLoading = false;
      }
    }
    /**
     * Met à jour l'état du bouton "more" en fonction de la page actuelle
     * @private
     */
    updateMoreButton() {
      if (!this.btnMore) return;
      if (this.currentPage >= this.maxPages) {
        this.btnMore.setAttribute("disabled", "disabled");
        this.btnMore.classList.add("button-disabled");
      } else {
        this.btnMore.removeAttribute("disabled");
        this.btnMore.classList.remove("button-disabled");
      }
    }
    disconnectedCallback() {
      if (this.btnMore) {
        this.btnMore.removeEventListener("click", this.loadMoreProducts);
      }
      window.removeEventListener("popstate", this.checkUrlOnLoad);
    }
  };
  customElements.define("t-collection", TCollection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cross-sell"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/mini-cross-sell/mini-cross-sell.ts — do not edit directly.
// src/sections/mini-cross-sell/mini-cross-sell.ts
"use strict";
(() => {
  // src/sections/mini-cross-sell/mini-cross-sell.ts
  var MiniCrossSell = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-mini-cross-sell")) {
    window.customElements.define("c-mini-cross-sell", MiniCrossSell);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-add-to-cart"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/popup-add-to-cart/popup-add-to-cart.ts — do not edit directly.
// src/sections/popup-add-to-cart/popup-add-to-cart.ts
"use strict";
(() => {
  // src/sections/popup-add-to-cart/popup-add-to-cart.ts
  var _CPopupAtc = class _CPopupAtc extends HTMLElement {
    constructor() {
      super();
      this.timeout = null;
      this.openAnimationTimeout = null;
      this.dialog = this.querySelector("dialog");
      this.lastFocusedElement = null;
      this.openedViaKeyboard = false;
      this.pendingTrigger = null;
      this.pendingOpenedViaKeyboard = false;
      this.onKeydown = this.handleKeydown.bind(this);
      this.onDocumentClickCapture = this.handleDocumentClickCapture.bind(this);
      this.onDocumentSubmitCapture = this.handleDocumentSubmitCapture.bind(this);
    }
    connectedCallback() {
      document.addEventListener("click", this.onDocumentClickCapture, true);
      document.addEventListener("submit", this.onDocumentSubmitCapture, true);
      document.addEventListener("cart:add-success", (e) => {
        if (e.detail?.action === "add") {
          this.open();
        }
      });
      this.addEventListener("click", (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest("[data-popup-atc-close]")) {
          this.close();
        }
      });
      this.dialog?.addEventListener("close", () => {
        this.onDialogClosed();
      });
      this.dialog?.addEventListener("mouseover", (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest("[data-popup-atc-container]")) {
          clearTimeout(this.timeout ?? void 0);
        }
      });
      this.dialog?.addEventListener("mouseout", (event) => {
        const mouseEvent = event;
        const target = mouseEvent.target;
        if (!(target instanceof Element)) return;
        const container = target.closest("[data-popup-atc-container]");
        if (!container) return;
        const related = mouseEvent.relatedTarget;
        if (related instanceof Node && container.contains(related)) return;
        this.startCloseTimeout();
      });
      this.dialog?.addEventListener("focusin", () => {
        clearTimeout(this.timeout ?? void 0);
      });
      this.dialog?.addEventListener("focusout", (event) => {
        const related = event.relatedTarget;
        if (related instanceof Node && this.dialog?.contains(related)) return;
        if (!this.dialog?.open || !this.dialog.classList.contains("active"))
          return;
        this.startCloseTimeout();
      });
    }
    open() {
      if (!this.dialog) return;
      if (!this.dialog.open) {
        this.applyPendingTrigger();
      }
      document.documentElement.classList.add("is-overflow-hidden");
      this.updatePosition();
      if (typeof this.dialog.showModal === "function" && !this.dialog.open) {
        this.dialog.showModal();
      }
      document.addEventListener("keydown", this.onKeydown);
      clearTimeout(this.openAnimationTimeout ?? void 0);
      this.openAnimationTimeout = setTimeout(() => {
        if (!this.dialog?.open) return;
        this.dialog.classList.add("active");
        this.announceItemAdded();
        window.setTimeout(() => {
          if (!this.dialog?.open) return;
          this.focusPopup();
          this.startCloseTimeout();
        }, 100);
      }, 10);
    }
    close() {
      if (!this.dialog) return;
      this.dialog.classList.remove("active");
      if (typeof this.dialog.close === "function" && this.dialog.open) {
        this.dialog.close();
      } else {
        this.onDialogClosed();
      }
    }
    /**
     * Shared cleanup for programmatic close and native dialog `close` (Escape).
     */
    onDialogClosed() {
      document.documentElement.classList.remove("is-overflow-hidden");
      document.removeEventListener("keydown", this.onKeydown);
      clearTimeout(this.timeout ?? void 0);
      clearTimeout(this.openAnimationTimeout ?? void 0);
      this.dialog?.classList.remove("active");
      this.openedViaKeyboard = false;
      this.restoreTriggerFocus();
    }
    /**
     * Stashes ATC submit controls on click (capture) before they are disabled.
     */
    handleDocumentClickCapture(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const control = target.closest(
        [
          'c-product-form button[type="submit"]',
          'c-product-form [type="submit"]',
          "[data-product-form-submit]"
        ].join(", ")
      );
      if (!(control instanceof HTMLElement)) return;
      if (control.hasAttribute("disabled")) return;
      this.stashTrigger(control);
    }
    /**
     * Stashes the focused control on submit (capture) — covers Enter on a
     * focused submit button when click ordering differs by browser.
     */
    handleDocumentSubmitCapture(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest("c-product-form") && !form.closest("c-sticky-composition-bar")) {
        return;
      }
      const active = document.activeElement;
      if (!(active instanceof HTMLElement)) return;
      if (active === document.body || active === document.documentElement) return;
      if (this.dialog?.contains(active)) return;
      this.stashTrigger(active);
    }
    /**
     * Records the trigger and whether it was activated with a visible focus ring.
     * `:focus-visible` must be read here — by `open()` the control is already blurred.
     */
    stashTrigger(element) {
      this.pendingTrigger = element;
      try {
        this.pendingOpenedViaKeyboard = element.matches(":focus-visible");
      } catch {
        this.pendingOpenedViaKeyboard = document.activeElement === element;
      }
    }
    /**
     * Moves a stashed trigger into `lastFocusedElement` for close/restore.
     */
    applyPendingTrigger() {
      if (this.pendingTrigger) {
        this.lastFocusedElement = this.pendingTrigger.isConnected ? this.pendingTrigger : null;
        this.openedViaKeyboard = this.pendingOpenedViaKeyboard;
        this.pendingTrigger = null;
        this.pendingOpenedViaKeyboard = false;
        return;
      }
      const active = document.activeElement;
      if (active instanceof HTMLElement && active !== document.body && active !== document.documentElement && !this.dialog?.contains(active)) {
        this.lastFocusedElement = active;
        try {
          this.openedViaKeyboard = active.matches(":focus-visible");
        } catch {
          this.openedViaKeyboard = false;
        }
      }
    }
    /**
     * Moves keyboard focus into the popup (close button preferred).
     * Runs after section HTML swap because `cart:add-success` fires post-render.
     */
    focusPopup() {
      const closeButton = this.dialog?.querySelector(
        "button[data-popup-atc-close]"
      );
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
        return;
      }
      this.dialog?.setAttribute("tabindex", "-1");
      this.dialog?.focus({ preventScroll: true });
    }
    /**
     * Returns focus to the Add-to-cart control that opened the popup.
     */
    restoreTriggerFocus() {
      if (this.lastFocusedElement?.isConnected) {
        this.lastFocusedElement.focus({ preventScroll: true });
      }
      this.lastFocusedElement = null;
    }
    /**
     * Announces the added product to screen readers only (sr-only live region
     * inside the dialog). A body-level region would be inert under showModal().
     */
    announceItemAdded() {
      const status = this.dialog?.querySelector(
        "[data-popup-atc-status]"
      );
      if (!status) return;
      const title = this.dialog?.querySelector(".product-name")?.textContent?.trim() || "Item";
      const template = this.dataset.itemAddedTemplate || "__TITLE__ was added to bag";
      const message = template.replace("__TITLE__", title);
      status.textContent = "";
      requestAnimationFrame(() => {
        status.textContent = message;
      });
    }
    /**
     * Cycles Tab / Shift+Tab inside the dialog so focus cannot leave to the
     * browser chrome (native modal still allows that escape at the edges).
     */
    handleKeydown(event) {
      if (event.key !== "Tab" || !this.dialog?.open) return;
      const focusable = this.getFocusableElements(this.dialog);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) {
        event.preventDefault();
        this.focusPopup();
        return;
      }
      const active = document.activeElement;
      const inside = active instanceof Node && this.dialog.contains(active);
      if (event.shiftKey) {
        if (!inside || active === first) {
          event.preventDefault();
          last.focus();
        }
        return;
      }
      if (!inside || active === last) {
        event.preventDefault();
        first.focus();
      }
    }
    getFocusableElements(root) {
      const selector = [
        "a[href]",
        "button:not([disabled])",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        '[tabindex]:not([tabindex="-1"])'
      ].join(",");
      return Array.from(root.querySelectorAll(selector)).filter(
        (element) => {
          if (element.getAttribute("aria-hidden") === "true") return false;
          if (typeof element.checkVisibility === "function") {
            return element.checkVisibility({
              checkOpacity: false,
              checkVisibilityCSS: true
            });
          }
          return window.getComputedStyle(element).visibility !== "hidden";
        }
      );
    }
    startCloseTimeout() {
      clearTimeout(this.timeout ?? void 0);
      const delay = this.openedViaKeyboard ? _CPopupAtc.CLOSE_MS_KEYBOARD : _CPopupAtc.CLOSE_MS_POINTER;
      this.timeout = setTimeout(() => this.close(), delay);
    }
    updatePosition() {
      const header = document.querySelector(".header") || document.querySelector("header");
      if (!header || !this.dialog) return;
      const rect = header.getBoundingClientRect();
      const headerBottom = rect.bottom;
      const raw = getComputedStyle(this.dialog).getPropertyValue("--header-block-size").trim();
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      const headerBlockSize = raw.endsWith("rem") ? parseFloat(raw) * rootFontSize : parseFloat(raw) || 68;
      const offset = Math.max(0, headerBottom - headerBlockSize);
      this.dialog.style.setProperty("--header-overhead-offset", `${offset}px`);
    }
  };
  _CPopupAtc.CLOSE_MS_POINTER = 3e3;
  _CPopupAtc.CLOSE_MS_KEYBOARD = 15e3;
  var CPopupAtc = _CPopupAtc;
  if (!customElements.get("c-popup-atc")) {
    customElements.define("c-popup-atc", CPopupAtc);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/product-information/product-information.ts — do not edit directly.
// src/sections/product-information/product-information.ts
"use strict";
(() => {
  // src/sections/product-information/product-information.ts
  var FOCUSABLE_SELECTOR = [
    "a[href]",
    "button:not([disabled])",
    "textarea:not([disabled])",
    'input:not([disabled]):not([type="hidden"])',
    "select:not([disabled])",
    '[tabindex]:not([tabindex="-1"])'
  ].join(", ");
  var ProductInformation = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.activeSidebar = null;
      this.isAnimating = false;
      this.triggerButtons = [];
      this.closeButtons = [];
      this.lastFocusedElement = null;
      this.onTriggerClick = (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const sidebarId = target?.dataset.informationSidebar;
        if (!sidebarId) return;
        this.openSidebar(sidebarId);
      };
      this.onCloseClick = (event) => {
        event.preventDefault();
        if (!this.activeSidebar) return;
        this.closeSidebar();
      };
      this.onDocumentKeydown = (event) => {
        if (!this.activeSidebar) return;
        if (event.key === "Escape") {
          this.closeSidebar({ force: true });
          return;
        }
        if (event.key === "Tab") {
          this.trapFocus(event);
        }
      };
    }
    connectedCallback() {
      this.triggerButtons = Array.from(
        this.querySelectorAll("[data-information-sidebar]")
      );
      this.closeButtons = Array.from(
        document.querySelectorAll(
          "[data-information-sidebar-close]"
        )
      );
      this.triggerButtons.forEach((button) => {
        button.addEventListener("click", this.onTriggerClick);
      });
      this.closeButtons.forEach((button) => {
        button.addEventListener("click", this.onCloseClick);
      });
    }
    disconnectedCallback() {
      this.triggerButtons.forEach((button) => {
        button.removeEventListener("click", this.onTriggerClick);
      });
      this.closeButtons.forEach((button) => {
        button.removeEventListener("click", this.onCloseClick);
      });
      document.removeEventListener("keydown", this.onDocumentKeydown);
      if (this.activeSidebar) {
        this.closeSidebar();
      }
    }
    /**
     * Syncs aria-expanded on every trigger for the open/closed sidebar id.
     */
    syncTriggerExpanded(sidebarId) {
      this.triggerButtons.forEach((button) => {
        const expanded = button.dataset.informationSidebar === sidebarId ? "true" : "false";
        button.setAttribute("aria-expanded", expanded);
      });
    }
    getActiveSidebarElement() {
      if (!this.activeSidebar) return null;
      return document.querySelector(
        `[data-information-sidebar-content="${this.activeSidebar}"]`
      );
    }
    getFocusableElements(container) {
      return Array.from(
        container.querySelectorAll(FOCUSABLE_SELECTOR)
      ).filter((element) => {
        if (element.hasAttribute("disabled") || element.getAttribute("aria-hidden") === "true" || element.tabIndex === -1) {
          return false;
        }
        if (typeof element.checkVisibility === "function") {
          return element.checkVisibility({
            checkOpacity: false,
            checkVisibilityCSS: true
          });
        }
        return window.getComputedStyle(element).visibility !== "hidden";
      });
    }
    trapFocus(event) {
      const sidebar = this.getActiveSidebarElement();
      if (!sidebar) return;
      const focusableElements = this.getFocusableElements(sidebar);
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (!firstElement || !lastElement) {
        event.preventDefault();
        return;
      }
      const activeElement = document.activeElement;
      if (event.shiftKey) {
        if (activeElement === firstElement || !(activeElement instanceof Node) || !sidebar.contains(activeElement)) {
          event.preventDefault();
          lastElement.focus();
        }
        return;
      }
      if (activeElement === lastElement || !(activeElement instanceof Node) || !sidebar.contains(activeElement)) {
        event.preventDefault();
        firstElement.focus();
      }
    }
    openSidebar(sidebarId) {
      if (this.isAnimating) return;
      const sidebar = document.querySelector(
        `[data-information-sidebar-content="${sidebarId}"]`
      );
      if (!sidebar) return;
      this.isAnimating = true;
      this.activeSidebar = sidebarId;
      this.lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      this.syncTriggerExpanded(sidebarId);
      if (sidebar.parentNode !== document.body) {
        document.body.appendChild(sidebar);
      }
      document.body.classList.add("is-overflow-hidden");
      document.addEventListener("keydown", this.onDocumentKeydown);
      sidebar.classList.add("active");
      const closeButton = sidebar.querySelector(
        "button[data-information-sidebar-close]"
      );
      if (closeButton) {
        closeButton.focus();
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          sidebar.querySelector(".reinsurances-custom__sidebar-content")?.classList.add("active");
        });
      });
      window.setTimeout(() => {
        this.isAnimating = false;
      }, 400);
    }
    closeSidebar(options = {}) {
      if (!options.force && this.isAnimating || !this.activeSidebar) return;
      this.isAnimating = true;
      const sidebar = this.getActiveSidebarElement();
      if (!sidebar) {
        this.isAnimating = false;
        return;
      }
      sidebar.querySelector(".reinsurances-custom__sidebar-content")?.classList.remove("active");
      document.body.classList.remove("is-overflow-hidden");
      document.removeEventListener("keydown", this.onDocumentKeydown);
      sidebar.classList.remove("active");
      this.activeSidebar = null;
      this.syncTriggerExpanded(null);
      this.isAnimating = false;
      if (this.lastFocusedElement) {
        this.lastFocusedElement.focus();
        this.lastFocusedElement = null;
      }
    }
  };
  if (!window.customElements.get("c-product-information")) {
    window.customElements.define("c-product-information", ProductInformation);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
    
  //@ts-check
  class CFaq extends HTMLElement {
    constructor() {
      super()

      this.faqItems = this.querySelectorAll('.faq--item')
    }
    connectedCallback() {
      this.faqItems.forEach((item) => {
        const btn = item.querySelector('.faq--item--header')
        const content = item.querySelector('.faq--item--content')
        btn.setAttribute('aria-expanded', 'false')
        content.style.height = '0'
        btn.addEventListener('click', () => {
          const isOpen = btn.getAttribute('aria-expanded') === 'true'
          btn.setAttribute('aria-expanded', String(!isOpen))
          content.style.height = isOpen ? '0' : content.scrollHeight + 16 + 'px'
        })
      })
    }
  }
  if (!customElements.get('c-faq')) {
    customElements.define('c-faq', CFaq)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-in-page-nav"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/section-in-page-nav/section-in-page-nav.ts — do not edit directly.
// src/sections/section-in-page-nav/section-in-page-nav.ts
"use strict";
(() => {
  // src/sections/section-in-page-nav/section-in-page-nav.ts
  var REFRESH_DEBOUNCE_MS = 400;
  function isDesignMode() {
    return Boolean(window.Shopify?.designMode);
  }
  var SectionInPageNav = class extends HTMLElement {
    constructor() {
      super(...arguments);
      /** @type {HTMLElement[]} */
      this.navItems = [];
      this.navSections = [];
      /** @type {Map<HTMLElement, string[]>} */
      this.navItemTargetIds = /* @__PURE__ */ new Map();
      /** @type {Map<string, HTMLElement>} */
      this.targetIdToNavItem = /* @__PURE__ */ new Map();
      /** @type {Map<string, HTMLElement>} */
      this.navSectionsByTargetId = /* @__PURE__ */ new Map();
      /** @type {Map<string, SectionPlacement>} */
      this.sectionPlacements = /* @__PURE__ */ new Map();
      /** @type {HTMLElement[]} */
      this.tabPanels = [];
      this.navLayoutOption = "";
      this.configObserver = null;
      this.refreshTimer = null;
      this.morphPending = false;
      this.boundHandleClick = this.handleClick.bind(this);
      this.boundHandleScroll = this.handleScroll.bind(this);
      this.boundHandleSectionLoad = this.handleSectionLoad.bind(this);
      this.boundHandleSectionUnload = this.handleSectionUnload.bind(this);
    }
    connectedCallback() {
      this.setup();
      this.bindDesignModeObservers();
    }
    disconnectedCallback() {
      this.unbindDesignModeObservers();
      this.teardownListeners();
      this.restoreDom();
    }
    setup() {
      this.navLayoutOption = this.dataset.layoutOption ?? "";
      if (!isDesignMode()) {
        this.reOrderDom();
      }
      this.navItems = Array.from(
        this.querySelectorAll(".section-in-page-nav__item")
      );
      this.cacheNavItemTargetIds();
      this.navItems.forEach((navItem) => {
        navItem.addEventListener("click", this.boundHandleClick);
      });
      if (this.navLayoutOption === "tabs") {
        if (isDesignMode()) {
          if (this.navItems.length > 0) {
            this.navItems[0].classList.add("is-active");
          }
          return;
        }
        this.initializeTabs();
        return;
      }
      if (this.navLayoutOption === "anchors" && !isDesignMode()) {
        window.addEventListener("scroll", this.boundHandleScroll);
      }
    }
    teardownListeners() {
      this.navItems.forEach((navItem) => {
        navItem.removeEventListener("click", this.boundHandleClick);
      });
      if (this.navLayoutOption === "anchors") {
        window.removeEventListener("scroll", this.boundHandleScroll);
      }
    }
    cancelScheduledRefresh() {
      if (this.refreshTimer === null) return;
      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
    /**
     * Runs after Shopify finishes morphing the section HTML.
     * Double rAF ensures Liquid output is in the DOM before we move sections.
     */
    scheduleSetupAfterMorph() {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.teardownListeners();
          this.restoreDom();
          this.setup();
        });
      });
    }
    /**
     * Fallback when the editor morphs data attributes without firing section events.
     * Debounced and skipped while a section unload/load cycle is in progress.
     */
    scheduleRefresh() {
      if (!isDesignMode() || this.morphPending) return;
      this.cancelScheduledRefresh();
      this.refreshTimer = window.setTimeout(() => {
        this.refreshTimer = null;
        if (!this.isConnected || this.morphPending) return;
        this.pauseConfigObserver();
        this.scheduleSetupAfterMorph();
        window.requestAnimationFrame(() => {
          this.resumeConfigObserver();
        });
      }, REFRESH_DEBOUNCE_MS);
    }
    restoreDom() {
      const idsToRestore = /* @__PURE__ */ new Set([
        ...this.getOrderedTargetIds(),
        ...this.navSections.map(
          (targetSection) => targetSection.dataset.internalName ?? ""
        ),
        ...this.sectionPlacements.keys()
      ]);
      const restoredSections = /* @__PURE__ */ new Set();
      [...idsToRestore].reverse().forEach((targetId) => {
        if (!targetId) return;
        const targetSection = this.findTargetSectionWrapper(targetId);
        if (!targetSection || restoredSections.has(targetSection)) return;
        if (!this.contains(targetSection)) return;
        this.restoreSectionToPlacement(targetSection, targetId);
        restoredSections.add(targetSection);
      });
      this.querySelectorAll('[role="tabpanel"]').forEach((panelEl) => {
        if (!(panelEl instanceof HTMLElement)) return;
        if (panelEl.closest("c-section-in-page-nav") !== this) return;
        Array.from(panelEl.children).forEach((child) => {
          if (!(child instanceof HTMLElement)) return;
          if (restoredSections.has(child)) return;
          const targetId = child.dataset.internalName ?? "";
          if (!targetId) return;
          this.restoreSectionToPlacement(child, targetId);
          restoredSections.add(child);
        });
        panelEl.remove();
      });
      Array.from(this.children).forEach((child) => {
        if (!(child instanceof HTMLElement)) return;
        if (child.classList.contains("section-in-page-nav__items")) return;
        if (child.getAttribute("role") === "tabpanel") return;
        if (restoredSections.has(child)) return;
        const targetId = child.dataset.internalName ?? "";
        if (!targetId) return;
        this.restoreSectionToPlacement(child, targetId);
        restoredSections.add(child);
      });
      this.navSections = [];
      this.navSectionsByTargetId = /* @__PURE__ */ new Map();
      this.tabPanels = [];
    }
    restoreSectionToPlacement(targetSection, targetId) {
      const placement = this.sectionPlacements.get(targetId);
      if (placement?.parent.isConnected) {
        placement.parent.insertBefore(targetSection, placement.nextSibling);
        return;
      }
      const freshParent = this.findFreshTargetSection(targetId);
      if (freshParent && freshParent !== targetSection) {
        freshParent.appendChild(targetSection);
      }
    }
    pauseConfigObserver() {
      this.configObserver?.disconnect();
      this.configObserver = null;
    }
    resumeConfigObserver() {
      if (!isDesignMode() || this.configObserver) return;
      this.configObserver = new MutationObserver(() => {
        this.scheduleRefresh();
      });
      this.configObserver.observe(this, {
        attributes: true,
        attributeFilter: ["data-target-ids", "data-layout-option"],
        subtree: true
      });
    }
    bindDesignModeObservers() {
      if (!isDesignMode()) return;
      this.resumeConfigObserver();
      document.addEventListener(
        "shopify:section:load",
        this.boundHandleSectionLoad
      );
      document.addEventListener(
        "shopify:section:unload",
        this.boundHandleSectionUnload
      );
    }
    unbindDesignModeObservers() {
      this.configObserver?.disconnect();
      this.configObserver = null;
      document.removeEventListener(
        "shopify:section:load",
        this.boundHandleSectionLoad
      );
      document.removeEventListener(
        "shopify:section:unload",
        this.boundHandleSectionUnload
      );
      this.cancelScheduledRefresh();
      this.morphPending = false;
    }
    handleSectionUnload(event) {
      const eventTarget = event.target;
      if (!(eventTarget instanceof HTMLElement)) return;
      if (!eventTarget.contains(this)) return;
      this.morphPending = true;
      this.cancelScheduledRefresh();
      this.pauseConfigObserver();
      this.teardownListeners();
      this.restoreDom();
    }
    handleSectionLoad(event) {
      const eventTarget = event.target;
      if (!(eventTarget instanceof HTMLElement)) return;
      if (!eventTarget.contains(this)) return;
      this.morphPending = false;
      this.cancelScheduledRefresh();
      this.scheduleSetupAfterMorph();
      window.requestAnimationFrame(() => {
        this.resumeConfigObserver();
      });
    }
    /**
     * Finds an element by exact data-internal-name value.
     * Avoids CSS selector escaping issues with apostrophes, slashes, etc.
     */
    findElementByInternalName(targetId) {
      const elements = document.querySelectorAll(
        "[data-internal-name]"
      );
      for (const element of elements) {
        if (!(element instanceof HTMLElement)) continue;
        if (element.closest("c-section-in-page-nav") === this) continue;
        if (element.getAttribute("data-internal-name") === targetId) {
          return element;
        }
      }
      return null;
    }
    findFreshTargetSection(targetId) {
      const anchor = this.findElementByInternalName(targetId);
      return anchor?.parentElement ?? null;
    }
    /**
     * Finds a target section wrapper on the page or already managed inside the nav.
     */
    findTargetSectionWrapper(targetId) {
      const trackedSection = this.navSectionsByTargetId.get(targetId);
      if (trackedSection?.isConnected) return trackedSection;
      const outsideAnchor = this.findElementByInternalName(targetId);
      if (outsideAnchor?.parentElement) return outsideAnchor.parentElement;
      const managedElements = this.querySelectorAll(
        "[data-internal-name]"
      );
      for (const element of managedElements) {
        if (!(element instanceof HTMLElement)) continue;
        if (element.classList.contains("section-in-page-nav__items")) continue;
        if (element.getAttribute("data-internal-name") !== targetId) continue;
        return element;
      }
      return null;
    }
    /**
     * Target ids in nav-item block order, then comma order within each item.
     * More reliable than the aggregated root data-target-ids after editor morphs.
     */
    getOrderedTargetIds() {
      const navItemElements = Array.from(
        this.querySelectorAll(".section-in-page-nav__item")
      );
      const seen = /* @__PURE__ */ new Set();
      const result = [];
      navItemElements.forEach((navItem) => {
        const targetIds = this.parseTargetIds(
          navItem.dataset.targetIds ?? ""
        );
        targetIds.forEach((targetId) => {
          if (seen.has(targetId)) return;
          seen.add(targetId);
          result.push(targetId);
        });
      });
      return result;
    }
    reOrderDom() {
      this.navSections = [];
      this.navSectionsByTargetId = /* @__PURE__ */ new Map();
      const targetIds = this.getOrderedTargetIds();
      targetIds.forEach((targetId) => {
        const targetSection = this.findTargetSectionWrapper(targetId);
        if (!targetSection || targetSection === this) {
          return;
        }
        if (this.contains(targetSection)) return;
        if (!this.sectionPlacements.has(targetId)) {
          const parentElement = targetSection.parentElement;
          if (!parentElement) return;
          this.sectionPlacements.set(targetId, {
            parent: parentElement,
            nextSibling: targetSection.nextSibling
          });
        }
        targetSection.setAttribute("data-internal-name", targetId);
        this.navSections.push(targetSection);
        this.navSectionsByTargetId.set(targetId, targetSection);
        this.appendChild(targetSection);
      });
    }
    /**
     * Parses a raw list of internal section ids.
     * Accepts ids separated by commas and/or any whitespace (including new lines).
     */
    parseTargetIds(raw) {
      const trimmed = raw.trim();
      if (!trimmed) return [];
      const normalized = trimmed.replace(/\r\n/g, "\n").replace(/\n+/g, ",");
      const tokens = normalized.split(",");
      const seen = /* @__PURE__ */ new Set();
      const result = [];
      tokens.forEach((token) => {
        const cleaned = token.replace(/^#/, "").trim();
        if (!cleaned) return;
        if (seen.has(cleaned)) return;
        seen.add(cleaned);
        result.push(cleaned);
      });
      return result;
    }
    /**
     * Cache nav item target id lists and build an inverse map (targetId -> owner navItem).
     */
    cacheNavItemTargetIds() {
      this.navItemTargetIds = /* @__PURE__ */ new Map();
      this.targetIdToNavItem = /* @__PURE__ */ new Map();
      this.navItems.forEach((navItem) => {
        const rawTargetIds = navItem.dataset.targetIds ?? "";
        const targetIds = this.parseTargetIds(rawTargetIds);
        this.navItemTargetIds.set(navItem, targetIds);
        targetIds.forEach((targetId) => {
          if (!this.targetIdToNavItem.has(targetId)) {
            this.targetIdToNavItem.set(targetId, navItem);
          }
        });
      });
    }
    getFirstExistingTargetId(targetIds) {
      for (const targetId of targetIds) {
        if (this.navSectionsByTargetId.has(targetId)) return targetId;
        if (this.findElementByInternalName(targetId)) return targetId;
      }
      return "";
    }
    /**
     * Resolves the element to scroll to — moved sections live inside the nav
     * and are excluded from the global query in findElementByInternalName.
     */
    getScrollTarget(targetId) {
      const movedSection = this.navSectionsByTargetId.get(targetId);
      if (movedSection) return movedSection;
      return this.findElementByInternalName(targetId);
    }
    handleClick(event) {
      const eventTarget = event.target;
      if (!eventTarget) return;
      if (!(eventTarget instanceof Element)) return;
      const closestElement = eventTarget.closest(
        ".section-in-page-nav__item"
      );
      if (!closestElement || !(closestElement instanceof HTMLElement)) {
        return;
      }
      const targetNavItem = closestElement;
      const targetIds = this.navItemTargetIds.get(targetNavItem) ?? [];
      if (this.navLayoutOption === "tabs") {
        this.activateNavItem(targetNavItem);
      }
      const targetId = this.getFirstExistingTargetId(targetIds);
      if (!targetId) return;
      this.getScrollTarget(targetId)?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    initializeTabs() {
      this.tabPanels = [];
      let firstValidNavItem = null;
      this.navItems.forEach((navItem, index) => {
        const panelId = `section-in-page-nav-panel-${this.sectionId}-${index}`;
        const panelEl = document.createElement("div");
        panelEl.id = panelId;
        panelEl.setAttribute("role", "tabpanel");
        panelEl.setAttribute("aria-labelledby", navItem.id);
        panelEl.hidden = true;
        panelEl.style.display = "none";
        navItem.setAttribute("aria-controls", panelId);
        navItem.setAttribute("aria-selected", "false");
        const targetIds = this.navItemTargetIds.get(navItem) ?? [];
        let hasAnyTargetSection = false;
        targetIds.forEach((targetId) => {
          if (this.targetIdToNavItem.get(targetId) !== navItem) return;
          const targetSection = this.navSectionsByTargetId.get(targetId);
          if (!targetSection) return;
          panelEl.appendChild(targetSection);
          hasAnyTargetSection = true;
        });
        this.tabPanels.push(panelEl);
        this.appendChild(panelEl);
        if (!firstValidNavItem && hasAnyTargetSection) {
          firstValidNavItem = navItem;
        }
      });
      if (firstValidNavItem) {
        this.activateNavItem(firstValidNavItem);
      } else if (this.navItems.length > 0) {
        this.activateNavItem(this.navItems[0]);
      }
    }
    activateNavItem(activeNavItem) {
      this.navItems.forEach((navItem) => {
        navItem.classList.toggle("is-active", navItem === activeNavItem);
        navItem.setAttribute(
          "aria-selected",
          navItem === activeNavItem ? "true" : "false"
        );
      });
      this.tabPanels.forEach((panelEl, index) => {
        panelEl.hidden = !(this.navItems[index] === activeNavItem);
        panelEl.style.display = this.navItems[index] === activeNavItem ? "block" : "none";
      });
    }
    get sectionId() {
      return this.id || this.dataset.sectionId || "section";
    }
    handleScroll() {
      let activeTargetId = "";
      this.navSections.forEach((navSection) => {
        if (this.isCurrentSection(navSection)) {
          activeTargetId = navSection.dataset.internalName ?? "";
        }
      });
      this.navItems.forEach((navItem) => {
        const targetIds = this.navItemTargetIds.get(navItem) ?? [];
        if (targetIds.includes(activeTargetId)) {
          navItem.classList.add("is-active");
        } else {
          navItem.classList.remove("is-active");
          if (document.activeElement === navItem) {
            navItem.blur();
          }
        }
      });
    }
    isCurrentSection(navSection) {
      return navSection.getBoundingClientRect().top < 200;
    }
  };
  if (!window.customElements.get("c-section-in-page-nav")) {
    window.customElements.define("c-section-in-page-nav", SectionInPageNav);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-text-gallery-media"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/section-text-gallery-media/section-text-gallery-media.ts — do not edit directly.
// src/sections/section-text-gallery-media/section-text-gallery-media.ts
"use strict";
(() => {
  // src/sections/section-text-gallery-media/section-text-gallery-media.ts
  var SectionTextGalleryMedia = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-section-text-gallery-media")) {
    window.customElements.define(
      "c-section-text-gallery-media",
      SectionTextGalleryMedia
    );
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-to-compose-product"]) return;
  try {
    
// ⚠ Auto-generated from src/sections/set-to-compose-product/set-to-compose-product.ts — do not edit directly.
// src/sections/set-to-compose-product/set-to-compose-product.ts
"use strict";
(() => {
  // src/sections/set-to-compose-product/set-to-compose-product.ts
  var SetToComposeProduct = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.errorMessage = null;
      this.errorMessageButton = null;
      this.handleErrorMessageClose = () => {
        if (this.errorMessage && !this.errorMessage.classList.contains("hidden")) {
          this.errorMessage.classList.add("hidden");
        }
      };
    }
    connectedCallback() {
      this.errorMessage = this.querySelector(
        "[data-set-to-compose-error-message]"
      );
      this.errorMessageButton = this.errorMessage?.querySelector(
        ".set-to-compose-product_error-message_button"
      ) ?? null;
      this.errorMessageButton?.addEventListener(
        "click",
        this.handleErrorMessageClose
      );
    }
    disconnectedCallback() {
      this.errorMessageButton?.removeEventListener(
        "click",
        this.handleErrorMessageClose
      );
    }
  };
  if (!window.customElements.get("c-set-to-compose-product")) {
    window.customElements.define("c-set-to-compose-product", SetToComposeProduct);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/shoppable/shoppable.ts — do not edit directly.
// src/sections/shoppable/shoppable.ts
"use strict";
(() => {
  // src/sections/shoppable/shoppable.ts
  if (!window.shoppableInitialized) {
    window.shoppableInitialized = true;
    document.addEventListener("DOMContentLoaded", function() {
      const pins = document.querySelectorAll("[data-shoppable-pin]");
      const contents = document.querySelectorAll(
        "[data-shoppable-content]"
      );
      let lastFocusedPin = null;
      const closeAll = (restoreFocus) => {
        contents.forEach((content) => {
          content.classList.remove("active");
          content.setAttribute("aria-hidden", "true");
        });
        pins.forEach((pin) => {
          pin.setAttribute("aria-expanded", "false");
        });
        if (restoreFocus && lastFocusedPin) {
          lastFocusedPin.focus();
          lastFocusedPin = null;
        }
      };
      const positionContent = (pin, contentToOpen) => {
        const parent = pin.closest(".text-image__content-image");
        if (!parent) return;
        const parentRect = parent.getBoundingClientRect();
        const pinRect = pin.getBoundingClientRect();
        const contentWidth = 325;
        const contentHeight = 140;
        contentToOpen.style.position = "absolute";
        if (window.innerWidth <= 1024) {
          contentToOpen.style.top = "50%";
          contentToOpen.style.left = "50%";
          contentToOpen.style.transform = "translate(-50%, -50%)";
          return;
        }
        contentToOpen.style.transform = "none";
        const borderThreshold = 16;
        const pinLeftRelative = pinRect.left - parentRect.left;
        const pinTopRelative = pinRect.top - parentRect.top;
        const pinXPercent = pinLeftRelative / parentRect.width;
        const pinYPercent = pinTopRelative / parentRect.height;
        const isTop = pinYPercent < 0.5;
        const isLeft = pinXPercent < 0.5;
        let cardTop;
        let cardLeft;
        if (isTop && isLeft) {
          cardTop = pinTopRelative;
          cardLeft = pinLeftRelative + pinRect.width + 8;
        } else if (isTop && !isLeft) {
          cardTop = pinTopRelative;
          cardLeft = pinLeftRelative - contentWidth - 44;
        } else if (!isTop && isLeft) {
          cardTop = pinTopRelative + pinRect.height - contentHeight;
          cardLeft = pinLeftRelative + pinRect.width + 8;
        } else {
          cardTop = pinTopRelative + pinRect.height - contentHeight;
          cardLeft = pinLeftRelative - contentWidth - 44;
        }
        if (cardTop < borderThreshold) {
          cardTop = borderThreshold;
        } else if (cardTop + contentHeight > parentRect.height - borderThreshold) {
          cardTop = parentRect.height - contentHeight - borderThreshold;
        }
        if (cardLeft < borderThreshold) {
          cardLeft = borderThreshold;
        } else if (cardLeft + contentWidth > parentRect.width - borderThreshold) {
          cardLeft = parentRect.width - contentWidth - borderThreshold;
        }
        contentToOpen.style.top = `${cardTop}px`;
        contentToOpen.style.left = `${cardLeft}px`;
      };
      pins.forEach((pin) => {
        pin.addEventListener("click", function(e) {
          e.stopPropagation();
          const blockId = pin.getAttribute("data-block-id");
          const contentToOpen = document.querySelector(
            `[data-shoppable-content][data-block-id="${blockId}"]`
          );
          if (contentToOpen && contentToOpen.classList.contains("active")) {
            closeAll(true);
            return;
          }
          closeAll(false);
          lastFocusedPin = pin;
          if (!contentToOpen) return;
          positionContent(pin, contentToOpen);
          contentToOpen.classList.add("active");
          contentToOpen.setAttribute("aria-hidden", "false");
          pin.setAttribute("aria-expanded", "true");
          const focusTarget = contentToOpen.querySelector(
            'a, button, [tabindex]:not([tabindex="-1"])'
          ) ?? contentToOpen;
          focusTarget.focus();
        });
      });
      contents.forEach((content) => {
        content.addEventListener("click", function(e) {
          e.stopPropagation();
        });
      });
      document.addEventListener("click", function() {
        closeAll(true);
      });
      document.addEventListener("keydown", function(e) {
        if (e.key !== "Escape") return;
        const hasOpen = [...contents].some(
          (content) => content.classList.contains("active")
        );
        if (!hasOpen) return;
        e.preventDefault();
        closeAll(true);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotify"] && !Shopify.designMode) return;
  try {
    
// ⚠ Auto-generated from src/sections/spotify/spotify.ts — do not edit directly.
// src/sections/spotify/spotify.ts
"use strict";
(() => {
  // src/sections/spotify/spotify.ts
  var Spotify = class extends HTMLElement {
    connectedCallback() {
      const height = this.getAttribute("data-height");
      const iframe = this.querySelector("iframe");
      if (iframe) {
        iframe.style.height = `${height}px`;
      }
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-spotify")) {
    window.customElements.define("c-spotify", Spotify);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
